define('shared/initializer/form/adapters/mixins/CardinalLoginable',[
    'Promise',
    'shared/page/env',
    'shared/page/market',
    'shared/page/language',
    'shared/util/path/ResolverFactory',
    '../Login',
    'shared/remote/ajax',
    'shared/lib/cookie'
], function(
    Promise,
    getEnv,
    getMarket,
    getLanguage,
    PathResolverFactory,
    OldHouseLoginAdapter,
    ajax,
    cookie
){
    var ENDPOINT_BASE = {
        qa: 'https://qa-englishlive-systems.ef.com',
        uat: 'https://qa-englishlive-systems.ef.com',
        stg: 'http://stg-eflive.us-east-1.elasticbeanstalk.com',
        live: 'https://englishlive-systems.ef.com',
    };
    
    var QA_BASE = 'https://qa.marketing.englishlive.ef.com';
   
    var REDIRECTION_PATHS = {
        terms: '/accept-terms-and-conditions/?exp=v001',
        support: '/plans-and-prices-welcome-back',
        credits: '/contact-us/',
        account_not_active: '/plans-and-prices-alumni',
        suspended: '/contact-us',
        requested: '/account-suspended-request',
        charge: '/account-suspended-charge',
        oldHouse: '/plans-and-prices-welcome-back',
        locale: ''
    };

    function loginOldHouse($form) {
        $form[0].submit();
        /* WAITING FOR A DEFINITION
        throw new RedirectionSignal({
            sitePath: REDIRECTION_PATHS.oldHouse;
        });
        */
    }

    function post(url, data) {
        return getEnv()
            .then(function(env) {
                return ENDPOINT_BASE[env];
            })
            .then(function (endpointBase) {
                return ajax({
                    type: 'POST',
                    url: endpointBase + url,
                    data: data,
                    crossDomain: true
                });
            });
    }

    function FinishSignal() {

    }

    function RedirectionSignal(options) {
        this.url = options.url;
        this.sitePath = options.sitePath;
    }

    function getSiteBasePath() {
        return Promise.all([getMarket(), getLanguage()])
            .then(function(values) {
                var market = values[0];
                var language = values[1];
                return '/' + language + '-' + market;
            });
    }

    function redirect (redirectionSignal) {
        return Promise.resolve()
            .then(function(){
        		if (redirectionSignal.url) {
                    return redirectionSignal.url;
                } else {
                	return getEnv()
                    .then(function (env) {
                   	// that is right now only for testing on qa -> EFEL-1372
                    	if (env === 'qa') {
                    		 if (REDIRECTION_PATHS.locale == '') {
                                return getSiteBasePath()
                                     .then(function (siteBase) {
                                         return QA_BASE+siteBase + redirectionSignal.sitePath;
                                     });
                             } else {
                                return QA_BASE+'/' + REDIRECTION_PATHS.locale + redirectionSignal.sitePath;
                             }
                    	} else {
                    		if (REDIRECTION_PATHS.locale == '') {
                    			return getSiteBasePath()
                                   .then(function (siteBase) {
                                       return siteBase + redirectionSignal.sitePath;
                                   });
                    		} else {
                    			return '/' + REDIRECTION_PATHS.locale + redirectionSignal.sitePath;
                    		}
                    	}
                    });
                }
        	})
            .then(function (url) {
                window.location.href = url;
            });
    }

    function getAccountDoesNotExistError() {
        var err = new Error('Account does not exist');
        err.type = 'accountDoesNotExist';
        throw err;
    }

    function getInvalidCredentialError() {
        var err = new Error('Invalid credential');
        err.type = 'invalidCredential';
        throw err;
    }

    function Ctor() { }

    Ctor.prototype.doPageLoad = function() {
        var me = this;
        return OldHouseLoginAdapter.setupLoginForm(me.$form);
    };

    Ctor.prototype.doSubmit = function() {
        var me = this;
        var $form = me.$form;
        var $psd = $form.find('[name="Password"]');
        var $usr = $form.find('[name="UserName"]');
        var email = $usr.val();
        var password = $psd.val();

        return Promise.resolve()
            // check with dispatcher
            .then(function (){
                return post('/dispatcher/web', {
                    email: email
                });
            })
            .then(function (data) {
                if (!data) {
                    throw new Error('No response from server');
                }
                if (data.locale) REDIRECTION_PATHS.locale = data.locale;
                switch (data.response) {
                  case 'LoginNH':
                    return;
                  case 'LoginOH':
                    loginOldHouse($form);
                    throw new FinishSignal();
                  case 'NotExist':
                  default:
                    throw new Error('Unknown response from server');
                }
            })
            // prelogin
            .then(function () {
                return post('/prelogin/web', {
                    email: email
                });
            })
            .then(function (data) {
                if (!data) {
                    throw new Error('No response from server');
                }

                if (data.locale) REDIRECTION_PATHS.locale = data.locale;
                switch (data.code) {
                  case 'LOGIN':
                    return;
                  case 'CUSTOMER_SUPPORT':
                    throw new RedirectionSignal({
                       	sitePath: REDIRECTION_PATHS.support
                    });
                  case 'ACCOUNT_NOT_EXIST':
                    throw getAccountDoesNotExistError();
                  default:
                    throw new Error('Unknown response from server');
                }
            })
            // login
            .then(function () {
                return post('/login/web', {
                    email: email,
                    password: password
                });
            })
            .then(function (data) {
                if (!data) {
                    throw new Error('No response from server');
                }

                try {
                  var locale = data.locale.split("-");
                  var language = locale[0];
                  var market = locale[1];
                  switch (language) {
                    case 'ru':
                    	REDIRECTION_PATHS.credits = '/contact-us';
                    	break;
                    case 'es':
                    	REDIRECTION_PATHS.credits = '/contacto';
                    	break;
                    case 'de':
                    	REDIRECTION_PATHS.credits = '/kontakt';
                    	break;
                    case 'it':
                    	REDIRECTION_PATHS.credits = '/contatti';
                    	break;
                    case 'fr':
                    	REDIRECTION_PATHS.credits = '/contactez-nous';
                    	break;
                    default:
                    	REDIRECTION_PATHS.credits = '/contact-us';
                  }
                } catch (e) {
                  console.log("No locale found in server response");
                  console.log(e);
                }

                if (data.locale) REDIRECTION_PATHS.locale = data.locale;
                switch (data.code) {
                    case 'SUCCESS':
                        if (data.sfid) {
                            cookie.set('sfid', data.sfid, { path: '/' });
                        }
                        throw new RedirectionSignal({
                            url: data.user.continue_uri
                        });
                    case 'TERMS':
                        if (data.sfid) {
                            cookie.set('sfid', data.sfid, { path: '/' });
                            cookie.set('continue_uri', data.user.continue_uri, { path: '/' });
                        }
                        throw new RedirectionSignal({
                           	sitePath: REDIRECTION_PATHS.terms
                        });
                    case 'NO_CREDITS':
                        throw new RedirectionSignal({
                           	sitePath: REDIRECTION_PATHS.credits
                        });
                    case 'ACCOUNT_SUSPENDED':
                        throw new RedirectionSignal({
                           	sitePath: REDIRECTION_PATHS.suspended+(data.user_auth_token ? '#user_auth_token='+data.user_auth_token+'&expires_on='+data.expires_on : '')
                        });
                    case 'SUSPENSION_REQUESTED':
                        throw new RedirectionSignal({
                           	sitePath: REDIRECTION_PATHS.requested+(data.user_auth_token ? '#user_auth_token='+data.user_auth_token+'&expires_on='+data.expires_on : '')
                        });
                    case 'SUSPENSION_FAILED_PAYMENT':
                        throw new RedirectionSignal({
                           	sitePath: REDIRECTION_PATHS.charge+(data.user_auth_token ? '#user_auth_token='+data.user_auth_token+'&expires_on='+data.expires_on : '')
                        });
                    case 'ACCOUNT_NOT_ACTIVE':
                    	var redirectUri;
                    	const queryString = window.location.search;
                    	if (queryString) {
                    		const urlParams = new URLSearchParams(queryString);
                    		redirectUri = urlParams.get('redirect_uri');
                    	}
                    	if (redirectUri && redirectUri!=='') {
                    		throw new RedirectionSignal({
                    			url: redirectUri+(data.user_auth_token ? '#user_auth_token='+data.user_auth_token+'&expires_on='+data.expires_on : '')
                            });
                    	} else {
                    		throw new RedirectionSignal({
                                sitePath: REDIRECTION_PATHS.account_not_active+(data.user_auth_token ? '#user_auth_token='+data.user_auth_token+'&expires_on='+data.expires_on : '')
                            });
                    	}
                    case 'INVALID_CREDENTIAL':
                        throw getInvalidCredentialError();
                    default:
                        throw new Error('Unknown response from server');
                }
            })
            .then(function () {
                throw new Error('Unexpected execution path');
            }, function(err) {
                if (err instanceof FinishSignal) {
                    return;
                }

                if (err instanceof RedirectionSignal) {
                    return redirect(err);
                }

                if (!err.type) {
                    err.type = 'generic';
                }
                err.fatal = false;
                return Promise.reject(err);
            });
    };

    return Ctor;
});

